import { Truck, User } from "lucide-react";
import { MasterTable } from "../components/MasterTable";

const unitBadge = {
  Aktif: "bg-emerald-100 text-emerald-800 border border-emerald-200",
  "Masuk Bengkel": "bg-amber-100 text-amber-800 border border-amber-200",
};
const supirBadge = {
  Aktif: "bg-emerald-100 text-emerald-800 border border-emerald-200",
  Cuti: "bg-amber-100 text-amber-800 border border-amber-200",
  Resign: "bg-red-100 text-red-800 border border-red-200",
};

export default function MasterDataPage() {
  return (
    <div data-testid="master-data-page" className="space-y-6 max-w-6xl">
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-zinc-900">Master Data</h1>
        <p className="text-sm text-zinc-500 mt-1">Fondasi sistem: Master_Kendaraan &amp; Master_Supir — sumber relasi kolom Plat_Truk dan Nama_Supir di Trip Surat Jalan</p>
      </div>

      <MasterTable
        title="Master Kendaraan"
        icon={Truck}
        endpoint="kendaraan"
        keyField="Plat_Nomor"
        statusField="Status_Unit"
        statusBadge={unitBadge}
        testPrefix="kendaraan"
        importEntity="kendaraan"
        fields={[
          { key: "Plat_Nomor", label: "Plat Nomor", required: true, placeholder: "cth: BK 1234 AB" },
          { key: "Jenis_Truk", label: "Jenis Truk", required: true, options: ["Tangki CPO", "Truck", "Dump Truck"] },
          { key: "Masa_Berlaku_STNK", label: "Masa Berlaku STNK", type: "date" },
          { key: "Masa_Berlaku_KIR", label: "Masa Berlaku KIR", type: "date" },
          { key: "Status_Unit", label: "Status Unit", required: true, options: ["Aktif", "Masuk Bengkel"], default: "Aktif" },
        ]}
        columns={[
          { key: "Plat_Nomor", label: "Plat Nomor" },
          { key: "Jenis_Truk", label: "Jenis Truk" },
          { key: "Masa_Berlaku_STNK", label: "STNK s/d", date: true, warn: true },
          { key: "Masa_Berlaku_KIR", label: "KIR s/d", date: true, warn: true },
          { key: "Status_Unit", label: "Status Unit" },
        ]}
      />

      <MasterTable
        title="Master Supir"
        icon={User}
        endpoint="supir"
        keyField="Nama_Supir"
        statusField="Status_Supir"
        statusBadge={supirBadge}
        testPrefix="supir"
        importEntity="supir"
        fields={[
          { key: "Nama_Supir", label: "Nama Supir", required: true, placeholder: "cth: Budi Santoso" },
          { key: "NIK_KTP", label: "NIK KTP", placeholder: "16 digit NIK" },
          { key: "No_HP", label: "No. HP", placeholder: "cth: 0812xxxxxxx" },
          { key: "Status_Supir", label: "Status Supir", required: true, options: ["Aktif", "Cuti", "Resign"], default: "Aktif" },
        ]}
        columns={[
          { key: "Nama_Supir", label: "Nama Supir" },
          { key: "NIK_KTP", label: "NIK KTP" },
          { key: "No_HP", label: "No. HP" },
          { key: "Status_Supir", label: "Status Supir" },
        ]}
      />
    </div>
  );
}
